import { Card } from 'antd';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TableHeader from './components/TableHeader';
import Table from './components/worker/Table';
import { Paths } from 'constants/index';

const List = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const showActive = pathname.includes(Paths.WORKERS_ACTIVE);

  return (
    <>
      <Helmet title={`Kvalilog > ${t('pages.workers.title')}`} />
      <Card bordered={false} title={<TableHeader />}>
        <Table showActive={showActive} />
      </Card>
    </>
  );
};

export default List;
